import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'price',
})
export class PricePipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number,
    currencyCode: string = 'EUR',
    display: string = 'symbol',
    digits: string = '1.2-2',
  ): string {
    // Use the built-in CurrencyPipe to format the value
    const formattedCurrency = this.currencyPipe.transform(
      value,
      currencyCode,
      display,
      digits,
    );

    // Add a space between the symbol and the value
    return formattedCurrency?.replace('€', '€ ') || '';
  }
}
